import React, { FC } from "react";
import { useNewOrderDetails } from "./useNewOrderDetails";
import { initializeBusinessAction } from "../../slices/NewOrderCreateSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../slices/RootReducer";
import { useNavigate, useParams } from "react-router-dom";
import { AddPlanFinalize } from "../../components/plans/AddPlanFinalize";

export const NewOrderPayment: FC = () => {
  const { businessBuilder } = useSelector((state: RootState) => state.newOrder);
  const { businessId } = useParams();
  const orderDetails = useNewOrderDetails();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onBackClick = () => {
    if (businessId) {
      navigate(`/business/${businessId}/new/addons`);
    } else {
      navigate(`/new/addons`);
    }
  };

  const onPurchaseComplete = () => {
    const businessId = businessBuilder.id;
    navigate(`/business/${businessId}`);
    dispatch(initializeBusinessAction());
  };

  return (
    <AddPlanFinalize
      business={businessBuilder}
      orderDetails={orderDetails}
      onPurchased={onPurchaseComplete}
      onBackClick={onBackClick}
    />
  );
};
